module.exports = __webpack_public_path__ + "media/images/wusa_logo-572b2a429841d7dbbcef9862d2ac0ed3.png";